import { captureMessage } from '@sentry/react';

import type { ContractError } from '../api';

/** The server described the person in a shape this app cannot read; the team hears of it, the person keeps working. */
export const reportUnreadableDetails = (error: ContractError): void => {
  captureMessage('session.details-unreadable', { level: 'warning', tags: { feature: 'session' }, extra: { issues: error.issues } });
};
